import { useUrlState } from '@/hooks/useUrlState';
import { urlField } from '@/lib/urlState';

const USERS_SCHEMA = {
  page: urlField.page(),
  limit: urlField.number(20, { integer: true, min: 1, max: 200 }),
};

export function useAdminUsersFilters() {
  const [filters, setFilters] = useUrlState(USERS_SCHEMA);
  return { filters, setFilters };
}
